const langPackLocalVersion = 32;export default langPackLocalVersion;
